import styles from "./changePasswordModal.module.scss";
import { ModalWindow } from "../../shared/components/modalWindow/modalWindow";
import { useTranslation } from "react-i18next";
import {
  object,
  ref,
  string
} from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input } from "../../shared/components/input/input";
import { useUpdatePasswordMutation } from "../../api/services/user.service";
import { useEffect } from "react";

type ChangePasswordModalProps = {
  onClose: () => void;
}

export const ChangePasswordModal = ({ onClose }: ChangePasswordModalProps) => {
  const { t } = useTranslation();

  const [updatePassword, { isSuccess: isSuccessUpdate, isLoading: isLoadingUpdate }] = useUpdatePasswordMutation();

  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);

    return () => {
      window.removeEventListener('keydown', onKeyPress);
    }
  }, []);

  const onKeyPress = (e: KeyboardEvent): void => {
    if (e.key === "Enter") {
      onClickSave();
    }
  }

  useEffect(() => {
    if (isSuccessUpdate) {
      onClose();
    }
  }, [isSuccessUpdate]);

  const initialSchema = object().shape({
    newPassword: string().required(t("common.notValid")).typeError(t("common.notValid")),
    confirmPassword: string().required(t("common.notValid")).typeError(t("common.notValid")).oneOf([ref('newPassword')], t("common.notValid")),
  });

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(initialSchema),
  });

  const onClickSave = () => {
    handleSubmit((value) => {
      updatePassword(value.newPassword);
    })();
  }

  return (
    <ModalWindow title={t("main.changePassword")} onClose={onClose} width={380} children={
      <div className={styles.container}>
        <div className={styles.inputs}>
          <div className={styles.inputContainer}>
            <Input control={control}
                   name={"newPassword"}
                   type={"password"}
                   placeholder={t("main.enterNewPassword")}
                   error={!!errors.newPassword ? errors.newPassword.message : ""}/>
          </div>
          <div className={styles.inputContainer}>
            <Input control={control}
                   name={"confirmPassword"}
                   type={"password"}
                   placeholder={t("main.confirmPassword")}
                   error={!!errors.confirmPassword ? errors.confirmPassword.message as any : ""}/>
          </div>
        </div>
        <div className={styles.buttons}>
          <button className={styles.cancel}
                  disabled={isLoadingUpdate}
                  onClick={onClose}>{t("common.cancel")}</button>
          <button className={styles.save}
                  disabled={isLoadingUpdate}
                  onClick={onClickSave}>{t("common.save")}</button>
        </div>
      </div>
    }/>
  )
}